import React, { useState } from "react";
import { Modal } from "../../../../../../shared/Modal/Modal";
import { Footer } from "./shared/Footer";
import { useClinicOptions } from "./hooks/useClinicOptions";
import { Select } from "../../../../../../shared/Select/Select";
import { useSubmit } from "./hooks/useSubmit";
import { InputLabel } from "../../../../../../shared/InputLabel/InputLabel";

/**
 * @param {{
 *  clinicId: number;
 *  onClose: () => void;
 *  onForceDelete: () => void;
 *  onSuccess: () => void;
 * }} param0
 */
export var ModalTransferProducts = ({
  clinicId,
  onClose,
  onForceDelete,
  onSuccess,
}) => {
  var clinicOptions = useClinicOptions(clinicId);
  var submit = useSubmit(clinicId);
  var { 0: selectedClinic, 1: setSelectedClinic } = useState(null);

  return (
    <Modal
      isOpen
      footerNoBorder
      shouldCloseOnOverlayClick={false}
      onClose={onClose}
      header={<Modal.Title>Products Transfer</Modal.Title>}
      footer={
        <Footer
          onSubmit={() =>
            submit.initiate(selectedClinic?.value).then(onSuccess)
          }
          onForceDelete={onForceDelete}
          onCancel={onClose}
          isSubmitting={submit.isLoading}
        />
      }
    >
      <InputLabel>
        Which clinic would you like to transfer the products to?
      </InputLabel>
      <Select
        isSearchable
        options={clinicOptions}
        value={selectedClinic}
        onChange={setSelectedClinic}
      />
    </Modal>
  );
};
